var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import styled from '@emotion/styled';
import { useTranslation } from '@embed/hooks/react-i18nextLazy';
import assetPlay from '@images/embed/play@3x.png';
import { AccessibleIcon } from '../AccessibleIcon/AccessibleIcon';
const Icon = styled('button') `
  background-color: transparent;
  border-radius: 50%;
  border: 0;
  bottom: auto;
  box-sizing: border-box;
  left: 50%;
  margin: 0 !important;
  padding-left: 12px !important;
  padding: 10px !important;
  position: absolute;
  right: auto;
  top: 50%;
  transform: translate(-50%, -50%);
`;
const PlayButton = (props) => {
    const { hidePlayIcon, style } = props, rest = __rest(props, ["hidePlayIcon", "style"]);
    const { t } = useTranslation();
    return (<Icon style={Object.assign({ width: '70px', height: '70px', transform: 'translate(-50%, -50%)' }, (style || {}))} {...rest}>
      {!hidePlayIcon && (<AccessibleIcon src={assetPlay} height="100%" width="100%" alt={t('Play')}/>)}
    </Icon>);
};
export default PlayButton;
